import React from "react";
import "./SportsBlogPage.css";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function SportsBlogPage() {

    const navigate = useNavigate();
    const goToCricketPage = () => {
        window.scrollTo(0, 0);
        navigate('/cricket-homepage');
    };

    const handleRowClick = (team) => {
        navigate(`/points/${team.name}`, { state: team });
    };

    const posts = [
        {
            img: "/Images/web-poster copy.png",
            title: "ATPL Women’s T-20 Championship",
            desc: "India’s premier stage where emerging female cricketers rise to compete professionally with passion, precision and pride...",
            date: "12 Dec"
        },
        {
            img: "/Images/cricket-championship-tournament-match-background_30996-5837.jpg",
            title: "ATPL Men’s T-20 Championship",
            desc: "The Aattum Men’s T-20 Championship brings together the finest cricketing talents from across the nation for a thrilling, high-intensity battle of skill, speed, and strategy....",
            date: "06 jan"
        },
        {
            img: "/Images/image-3.png",
            title: "AATTUM TPL  Cricket League",
            desc: "AATTUM TPL T-20 Cricket League is a high-energy tournament designed to spotlight emerging cricket talent across all regions...",
            date: "02 Jan"
        },
        {
            img: "/Images/image-2.png",
            title: "AATTUM TPL Football League",
            desc: "AATTUM TPL Football League is a dynamic platform created to elevate young football talent across the nation...",
            date: "14 Jan"
        },
        {
            img: "/Images/image.png",
            title: "AATTUM TPL Kabaddi League",
            desc: "The AATTUM TPL Kabaddi League is a power-packed platform designed to promote young kabaddi talent from across the country...",
            date: "21 Jan"
        },
      
    ];

    const players = [
        { img: "/Images/teamlogo1.jpeg.jpg", name: "Risor sport", played: 7, wins: 5, points: 9 },
        { img: "/Images/teamlogo6.jpeg.jpg", name: "Super Kings", played: 7, wins: 5, points: 8 },
        { img: "/Images/teamlogo9.jpeg.jpg", name: "Neeraj Rathour", played: 7, wins: 4, points: 7 },
        { img: "/Images/teamlogo4.jpeg.jpg", name: "Guru Nanak college", played: 7, wins: 4, points: 6 },
        { img: "/Images/teamlogo2.jpeg.jpg", name: "Fearless Fighters", played: 7, wins: 3, points: 5 },
        { img: "/Images/teamlogo8.jpeg.jpg", name: "Queen Of Kolihills", played: 7, wins: 2, points: 4 },
        { img: "/Images/teamlogo3.jpeg.jpg", name: "AJVJ", played: 7, wins: 1, points: 3 },
        { img: "/Images/teamlogo5.jpeg.jpg", name: "Signature", played: 7, wins: 1, points: 2 },
        { img: "/Images/teamlogo7.jpeg.jpg", name: "Believe", played: 7, wins: 0, points: 1 },
    ];

    return (

      <>
    <header className="page-header-banner2531">
        <img
            src="/Images/stadium1.jpeg"
            alt="Sports Banner"
            className="page-header-img2531"
        />

        <div className="banner-overlay2531">
            <h1 className="banner-title2531">LATEST SPORTS NEWS & UPDATES</h1>
            <p className="banner-subtitle2531">Stay updated with matches, scores, and events</p>
        </div>
    </header>

    <div className="sports-page2531">

        <aside className="sidebar2531">

            <div className="sidebar-box2531">
                <h3 className="side-title2531">SEARCH</h3>

                <div className="search-wrapper2531">
                    <FiSearch className="search-icon2531" />
                    <input type="text" placeholder="Search..." className="search-bar2531" />
                </div>
            </div>

            <div className="sidebar-box2531">
                <h3 className="side-title2531">POINTS TABLE</h3>

                <table className="pointsTable2531">
                    <thead>
                        <tr>
                            <th>Team</th>
                            <th>P</th>
                            <th>W</th>
                            <th>PTS</th>
                        </tr>
                    </thead>

                    <tbody>
                        {players.map((team, index) => (
                            <tr key={index}>
                                <td className="teamCell2531">
                                    <img src={team.img} alt={team.name} className="team-logo2531" />
                                    {team.name}
                                </td>
                                <td>{team.played}</td>
                                <td>{team.wins}</td>
                                <td className="pointsHighlight2531">{team.points}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="sidebar-box2531">
                <h3 className="side-title2531">TAGS</h3>

                <div className="tags2531">
                    <span>Cricket</span>
                    <span>League</span>
                    <span>Training</span>
                    <span>Match Day</span>
                </div>
            </div>

            <div className="sidebar-box2531 next-event-box2531">
                <h3 className="side-title2531">NEXT EVENT</h3>

                <div className="next-event2531">
                    <img
                        src="/Images/web-03 copy.png"
                        alt="Event Banner"
                        className="event-banner2531"
                    />

                    <div className="date-badge2531">
                        <strong>DEC</strong>
                        <span>14</span>
                    </div>

                    <h4 className="event-title2531">AATTUM TPL T-20 Cricket League</h4>

                    <ul className="event-info2531">
                        <li>12 National-Level Women’s Cricket Teams</li>
                        <li>8 Days • 20 Power-Packed T20 Matches</li>
                    </ul>

                    <button className="event-btn2531" onClick={goToCricketPage}>
                        View Details
                    </button>
                </div>
            </div>
        </aside>

        {/* RIGHT CONTENT */}
        <section className="blog-grid2531">
            {posts.map((post, index) => (
                <div className="blog-card2531" key={index}>
                    <img src={post.img} alt="" className="blog-img2531" />
                    <div className="blog-content2531">
                        <span className="blog-date2531">{posts[index].date}</span>
                        <h3>{post.title}</h3>
                        <p>{post.desc}</p>

                        <div className="blog-footer2531">
                            <a href="#" className="read-more2531">READ MORE</a>
                        </div>
                    </div>
                </div>
            ))}
        </section>
    </div>
</>

    );
}
